import(/* webpackMode: "eager", webpackExports: ["AboutPageClient"] */ "/vercel/path0/app/about/AboutPageClient.tsx");
